import { generatePath, useHistory } from 'react-router';

import config from '@/config';

import { useSearchHistory } from '../../../hooks/useSearchHistory';
import { useSecretsAttributesFilter } from '../../../hooks/useSecretsAttributesFilter';
import { useSecretsNameFilter } from '../../../hooks/useSecretsNameFilter';
import { SearchOptionType, SearchSecretAttributeType } from '../../../types';
import type { Option, SearchOption } from '../types';
import { TAG_OPTION_VALUE_PREFIX } from '../utilities';

// eslint-disable-next-line no-prototype-builtins
export const isOption = (item: SearchOption): item is Option => !item.hasOwnProperty('options');

export const useHandleSearchSelect = (setSearchTerm: (value: string) => void) => {
    const history = useHistory();
    const { updateHistory } = useSearchHistory();

    const secretsNameFilter = useSecretsNameFilter();
    const secretsAttributesFilter = useSecretsAttributesFilter();

    const handleSelect = (value: string, option: SearchOption) => {
        if (!isOption(option)) return;

        switch (option.type) {
            case SearchOptionType.TAG: {
                const tag = option.value.replace(TAG_OPTION_VALUE_PREFIX, '');
                secretsAttributesFilter.toggleFilter(tag, tag, SearchSecretAttributeType.TAG, true);
                setSearchTerm(secretsNameFilter.filter);

                updateHistory({
                    value: tag,
                    label: tag,
                    type: SearchOptionType.TAG,
                });

                break;
            }
            case SearchOptionType.GROUP: {
                secretsAttributesFilter.toggleFilter(option.value, option.title, SearchSecretAttributeType.GROUP, true);
                setSearchTerm(secretsNameFilter.filter);

                updateHistory({
                    value: option.value,
                    label: option.title,
                    type: SearchOptionType.GROUP,
                });

                break;
            }
            case SearchOptionType.VAULT: {
                history.push(generatePath(config.routes.vault, { vaultId: value }));
                setSearchTerm(secretsNameFilter.filter);

                updateHistory({
                    value: option.value,
                    label: option.title,
                    type: SearchOptionType.VAULT,
                });

                break;
            }
            case SearchOptionType.RECORD: {
                history.push(
                    generatePath(config.routes.secret, {
                        id: value,
                    }),
                );
                setSearchTerm(secretsNameFilter.filter);

                updateHistory({
                    value: option.value,
                    label: option.title,
                    type: SearchOptionType.RECORD,
                });

                break;
            }
            default: {
                secretsNameFilter.updateFilter(value);

                updateHistory({
                    value: option.value,
                    label: option.value,
                    type: SearchOptionType.FILTER,
                });
            }
        }
    };

    return handleSelect;
};
